import React from 'react';
import {useSelector} from 'react-redux';
import * as S from './VerificationNeeded.styles';

import * as C from '../../Common.styles';
import {fullnameSelector, userCountrySelector} from '../../../../../store/selectors';
import IconSelector from '@ibibo/icon-selector';

const VerificationRequired = () => {
  const fullName = useSelector(fullnameSelector);
  const userCountry = useSelector(userCountrySelector);

  return (
    <S.AccountCreatedMainWrap>
      <S.AccountCreatedCommonWrap>
        <IconSelector iconKey="accountCreated" />
      </S.AccountCreatedCommonWrap>
      {!userCountry && (
        <S.AccountCreatedCommonWrap>
          <S.AccCreatedHeadText>
            <strong>Dear {fullName ? fullName : ''},</strong>
          </S.AccCreatedHeadText>
          <S.AccCreatedSubHeadText>
            Your myPartner Account Is Successfully Created!
          </S.AccCreatedSubHeadText>
        </S.AccountCreatedCommonWrap>
      )}
      <S.AccountCreatedCommonWrap>
        <S.AccCreatedInfoHeadText>
          Congratulations on registering with myPartner!
        </S.AccCreatedInfoHeadText>
        <S.AccCreatedInfoSubText>
          Our support team will contact you on your registered phone number for document
          verification within 24 hours.
        </S.AccCreatedInfoSubText>
      </S.AccountCreatedCommonWrap>
    </S.AccountCreatedMainWrap>
  );
};

export default VerificationRequired;
